import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import i18n from './i18n'

Vue.use(VueAxios, axios);

export const bus = new Vue();

Vue.config.productionTip = false
axios.interceptors.request.use(
    function(config) {
        // Do something before request is sent
        config.withCredentials = true;
        config.headers.common['Selected-Language'] = 'bg';
        return config;
    },
    function(error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app');
